
import React, { useEffect } from 'react'
import { Button, Table, Form, Input, Space, Select, message } from 'antd'


//导入样式
import '@/scss/common.scss'


//mobx
import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { runInAction, set, toJS } from 'mobx'


const Sheds = () => {
    //mobx
    const { PoliceStore } = useStore()
    const [form] = Form.useForm()

    //查询
    const onFinish = async (values) => {
        if (values.keyword) {
            let a = []
            a = values.keyword.split(',')
            await PoliceStore.getDataList(a[0])
        } else {
            message.error('请先选择设备名称再进行查询！')
        }

    }
    //重置
    const onReset = () => {
        form.resetFields()
    }
    //获得table数据
    useEffect(() => {
        runInAction(() => {
            set(PoliceStore, { filter: '' })
            set(PoliceStore, { op: '' })
            set(PoliceStore, { page: 1 })
            set(PoliceStore, { limit: 10 })
        })
        PoliceStore.getDataList()
        PoliceStore.newselect()
        // eslint-disable-next-line
    }, [])




    //分页控制
    const onPageChange = (page, pageSize) => {
        runInAction(() => {
            set(PoliceStore, { page: page })
            set(PoliceStore, { limit: pageSize })
        })
        PoliceStore.getDataList()
    }

    //下拉框
    const { Option } = Select;

    const columns = [
        {
            title: 'ID',
            dataIndex: 'ID',
        },
        {
            title: '规则名称',
            dataIndex: 'ConfigName',
        },
        {
            title: '设备名称',
            dataIndex: 'DevName',
        },
        {
            title: '属性名称',
            dataIndex: 'DisplayName',
        },
        {
            title: '比较',
            dataIndex: 'CompareType',
        },
        {
            title: '阈值',
            dataIndex: 'Value',
        },
        {
            title: '数值',
            dataIndex: 'AlarmValue',
        },
        {
            title: '告警时间',
            dataIndex: 'AlarmTime',
        },
        {
            title: '操作',
            render: (item) => (
                <Space size="middle">
                    {/* <a onClick={() => seedata(item, '查看数据')}>查看</a> */}
                </Space>
            ),
        },
    ]
    return (
        <>
            <div className='topTitle'>
                <div className='titleBtn'>报警记录</div>
            </div>
            <div className='searchBox'>
                <div className='TableInput'>
                    <Form layout="inline" onFinish={onFinish} form={form}>
                        <Form.Item label='设备名称'>
                            <Input.Group compact>
                                <Form.Item name='keyword'>
                                    <Select
                                        placeholder="请选择设备名称"
                                        style={{ width: '180px' }}
                                    >
                                        {
                                            PoliceStore.selectdata && (
                                                toJS(PoliceStore.selectdata).map((item) => {
                                                    return <Option value={item.value} key={item.value}>{item.label}</Option>
                                                })
                                            )
                                        }
                                    </Select>
                                </Form.Item>
                            </Input.Group>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                查询
                            </Button>
                            <Button htmlType="button" onClick={onReset} style={{ marginLeft: '15px' }}>
                                重置
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className='contextNr'>
                <Table rowKey={record => record.id} columns={columns} dataSource={PoliceStore.dataList} className='table-box' pagination={{
                    position: ['bottomRight'],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ['10', '20', '30'],
                    pageSize: PoliceStore.limit,
                    current: PoliceStore.page,
                    total: PoliceStore.total,
                    onChange: (page, pageSize) => onPageChange(page, pageSize),
                }} />
            </div>
        </>
    )
}

export default observer(Sheds)